export default __webpack_public_path__ + "static/media/candy-cane.ecc1553a.svg";